document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".safety-tips-header");
  const dropdown = document.querySelector(".faq-dropdown");
  const toggle = document.querySelector(".faq-dropdown-toggle");
  const dropdownText = document.querySelector(".faq-dropdown-text");
  const faqLinks = document.querySelectorAll(".faq-questions-list a");
  let isNavigating = false;

  if (toggle) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      dropdown.classList.toggle("open");
    });
  }

  document.addEventListener("click", function (e) {
    if (dropdown && !dropdown.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  });

  faqLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      isNavigating = true;

      if (dropdownText) {
        dropdownText.textContent = this.textContent;
      }

      if (dropdown) {
        dropdown.classList.remove("open");
      }

      if (header) {
        header.classList.add("faq-active");
      }

      const targetId = this.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetMargin = 12;
        const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - offsetMargin;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });

        setTimeout(() => {
          isNavigating = false;
        }, 1000);
      }
    });
  });

  window.addEventListener("scroll", () => {
    if (!isNavigating && header) {
      header.classList.remove("faq-active");
    }
  });
});